// TODO : Restyle all resource pages

import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './concussionAdvice.module.scss';
import recognizeImage from '../../assets/img/HIT007 C1-R-01-1.png';
import removeImage from '../../assets/img/HIT007 C1-R-02-1.png';
import referImage from '../../assets/img/HIT007 C1-R-03-1.png';
import restImage from '../../assets/img/HIT007 C1-R-04-1.png';
import recoverImage from '../../assets/img/HIT007 C1-R-05-1.png';
import returnImage from '../../assets/img/HIT007 C1-R-06-1.png';
import { MobileHeader } from '../../components/mobileHeader/mobileHeader';

export function ConcussionSixRsPage() {
  const { t } = useTranslation();

  return (
    <>
      <MobileHeader />
      <div className={styles.container}>
        <div className={styles.heading}>
          {t('resources.concussion.CONCUSSIONS_ADVICE_GUIDE_TITLE')}
        </div>
        <div className={styles.content}>
          <div className={styles.step}>
            <div className={styles.stepImage}>
              <img
                src={recognizeImage}
                alt={t(
                  'resources.concussion.CONCUSSIONS_ADVICE_GUIDE_HEADER_1',
                ).toString()}
              />
            </div>
            <div className={styles.stepTitle}>
              {t('resources.concussion.CONCUSSIONS_ADVICE_GUIDE_HEADER_1')}
            </div>
            <div className={styles.stepDescription}>
              {t('resources.concussion.CONCUSSIONS_ADVICE_GUIDE_DESCRIPTION_1')}
              <ul>
                <li>
                  {t(
                    'resources.concussion.CONCUSSIONS_ADVICE_GUIDE_DESCRIPTION_1_POINT_1',
                  )}
                </li>
                <li>
                  {t(
                    'resources.concussion.CONCUSSIONS_ADVICE_GUIDE_DESCRIPTION_1_POINT_2',
                  )}
                </li>
                <li>
                  {t(
                    'resources.concussion.CONCUSSIONS_ADVICE_GUIDE_DESCRIPTION_1_POINT_3',
                  )}
                </li>
                <li>
                  {t(
                    'resources.concussion.CONCUSSIONS_ADVICE_GUIDE_DESCRIPTION_1_POINT_4',
                  )}
                </li>
                <li>
                  {t(
                    'resources.concussion.CONCUSSIONS_ADVICE_GUIDE_DESCRIPTION_1_POINT_5',
                  )}
                </li>
                <li>
                  {t(
                    'resources.concussion.CONCUSSIONS_ADVICE_GUIDE_DESCRIPTION_1_POINT_6',
                  )}
                </li>
              </ul>
            </div>
          </div>
          <div className={styles.step}>
            <div className={styles.stepImage}>
              <img
                src={removeImage}
                alt={t(
                  'resources.concussion.CONCUSSIONS_ADVICE_GUIDE_HEADER_2',
                ).toString()}
              />
            </div>
            <div className={styles.stepTitle}>
              {t('resources.concussion.CONCUSSIONS_ADVICE_GUIDE_HEADER_2')}
            </div>
            <div className={styles.stepDescription}>
              {t('resources.concussion.CONCUSSIONS_ADVICE_GUIDE_DESCRIPTION_2')}
              <ul>
                <li>
                  {t(
                    'resources.concussion.CONCUSSIONS_ADVICE_GUIDE_DESCRIPTION_2_POINT_1',
                  )}
                </li>
                <li>
                  {t(
                    'resources.concussion.CONCUSSIONS_ADVICE_GUIDE_DESCRIPTION_2_POINT_2',
                  )}
                </li>
                <li>
                  {t(
                    'resources.concussion.CONCUSSIONS_ADVICE_GUIDE_DESCRIPTION_2_POINT_3',
                  )}
                </li>
                <li>
                  {t(
                    'resources.concussion.CONCUSSIONS_ADVICE_GUIDE_DESCRIPTION_2_POINT_4',
                  )}
                </li>
                <li>
                  {t(
                    'resources.concussion.CONCUSSIONS_ADVICE_GUIDE_DESCRIPTION_2_POINT_5',
                  )}
                </li>
                <li>
                  {t(
                    'resources.concussion.CONCUSSIONS_ADVICE_GUIDE_DESCRIPTION_2_POINT_6',
                  )}
                </li>
                <li>
                  {t(
                    'resources.concussion.CONCUSSIONS_ADVICE_GUIDE_DESCRIPTION_2_POINT_7',
                  )}
                </li>
                <li>
                  {t(
                    'resources.concussion.CONCUSSIONS_ADVICE_GUIDE_DESCRIPTION_2_POINT_8',
                  )}
                </li>
                <li>
                  {t(
                    'resources.concussion.CONCUSSIONS_ADVICE_GUIDE_DESCRIPTION_2_POINT_9',
                  )}
                </li>
              </ul>
            </div>
          </div>
          <div className={styles.step}>
            <div className={styles.stepImage}>
              <img
                src={referImage}
                alt={t(
                  'resources.concussion.CONCUSSIONS_ADVICE_GUIDE_HEADER_3',
                ).toString()}
              />
            </div>
            <div className={styles.stepTitle}>
              {t('resources.concussion.CONCUSSIONS_ADVICE_GUIDE_HEADER_3')}
            </div>
            <div className={styles.stepDescription}>
              {t('resources.concussion.CONCUSSIONS_ADVICE_GUIDE_DESCRIPTION_3')}
            </div>
          </div>
          <div className={styles.step}>
            <div className={styles.stepImage}>
              <img
                src={restImage}
                alt={t(
                  'resources.concussion.CONCUSSIONS_ADVICE_GUIDE_HEADER_4',
                ).toString()}
              />
            </div>
            <div className={styles.stepTitle}>
              {t('resources.concussion.CONCUSSIONS_ADVICE_GUIDE_HEADER_4')}
            </div>
            <div className={styles.stepDescription}>
              {t('resources.concussion.CONCUSSIONS_ADVICE_GUIDE_DESCRIPTION_4')}
            </div>
          </div>
          <div className={styles.step}>
            <div className={styles.stepImage}>
              <img
                src={recoverImage}
                alt={t(
                  'resources.concussion.CONCUSSIONS_ADVICE_GUIDE_HEADER_5',
                ).toString()}
              />
            </div>
            <div className={styles.stepTitle}>
              {t('resources.concussion.CONCUSSIONS_ADVICE_GUIDE_HEADER_5')}
            </div>
            <div className={styles.stepDescription}>
              {t('resources.concussion.CONCUSSIONS_ADVICE_GUIDE_DESCRIPTION_5')}
            </div>
          </div>
          <div className={styles.step}>
            <div className={styles.stepImage}>
              <img
                src={returnImage}
                alt={t(
                  'resources.concussion.CONCUSSIONS_ADVICE_GUIDE_HEADER_6',
                ).toString()}
              />
            </div>
            <div className={styles.stepTitle}>
              {t('resources.concussion.CONCUSSIONS_ADVICE_GUIDE_HEADER_6')}
            </div>
            <div className={styles.stepDescription}>
              {t('resources.concussion.CONCUSSIONS_ADVICE_GUIDE_DESCRIPTION_6')}
              <ul>
                <li>
                  {t(
                    'resources.concussion.CONCUSSIONS_ADVICE_GUIDE_DESCRIPTION_6_POINT_1',
                  )}
                </li>
                <li>
                  {t(
                    'resources.concussion.CONCUSSIONS_ADVICE_GUIDE_DESCRIPTION_6_POINT_2',
                  )}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
